"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var printer_1 = require("graphql/language/printer");
var lodash_get_1 = __importDefault(require("lodash.get"));
var react_1 = __importDefault(require("react"));
var App_1 = require("../../App");
var enums_1 = require("../../Common/utils/enums");
var simpleStore_1 = require("../../Common/utils/simpleStore");
var i18n_1 = __importDefault(require("../../i18n"));
var Providers_1 = require("../Providers");
var types_1 = require("../types");
var VerifyPaymentCardContext_1 = __importDefault(require("../VerifyPaymentCardContext"));
var VerifyPaymentCardStrings_1 = __importDefault(require("../VerifyPaymentCardStrings"));
var useGenerateVgsFormEffect_1 = __importDefault(require("./useGenerateVgsFormEffect"));
var useVgsPaymentConfig_1 = __importDefault(require("./useVgsPaymentConfig"));
var CHANNEL_MARKETPLACE = 'marketplace';
var VGS_VALIDATION_ERRORS = new Map([
    ['is required', VerifyPaymentCardStrings_1["default"].required()],
    ['is not a valid expiration date', VerifyPaymentCardStrings_1["default"].invalid()],
    ['is not a valid card number', VerifyPaymentCardStrings_1["default"].invalid()],
    ['is not a valid security code', VerifyPaymentCardStrings_1["default"].invalid()],
    ['default', VerifyPaymentCardStrings_1["default"].invalid()],
]);
/**
 * Handles success/ error after VGS tokenization without any VGS
 * native field validation errors.
 *
 * @param onSuccess Success callback to forward tokenized data.
 * @param onError Error callback for failures.
 * @param submit Call to make after successful tokenization of data.
 * @param billingAddress billing address details when applicable.
 * @param shouldCheckAddress Indicates the need to check for address field.
 * @returns void
 */
var handleSubmitFinish = function (onSuccess, onError, submit, billingAddress, shouldCheckAddress) { return function (status, response) {
    var _a;
    // The billing address field is not from VGS. So, we need to check
    // if its filled for second card challenge.
    if (shouldCheckAddress) {
        if (!billingAddress.addressLine1 || !billingAddress.zip) {
            onError({
                inlineErrors: (_a = {},
                    // tslint:disable-next-line:max-line-length
                    _a[types_1.VgsFormFieldName.BillingAddress] = VerifyPaymentCardStrings_1["default"].required(),
                    _a),
                globalError: undefined
            });
            return;
        }
    }
    // Handle server side errors. Could be from tokenization or redirection.
    if (status !== 200) {
        var message = JSON.stringify(response);
        onError({
            inlineErrors: {},
            globalError: {
                message: message,
                displayMsg: '',
                reason: 'vgs_failure',
                originalException: response
            }
        });
        return;
    }
    var tokenizedData = lodash_get_1["default"](response, 'data.cardChallengeVgsTokenizer');
    if (!tokenizedData) {
        var apolloError = lodash_get_1["default"](response, 'errors[0]');
        onError({
            inlineErrors: {},
            globalError: {
                displayMsg: (apolloError && apolloError.message) || '',
                reason: 'vgs_failure',
                message: (apolloError && apolloError.message) ||
                    "" + apolloError ||
                    'Unknown error occurred getting tokenized VGS card data',
                originalException: response
            }
        });
        return;
    }
    submit(tokenizedData)
        .then(function (result) {
        // Handle any error from card challenges.
        var errors = lodash_get_1["default"](result, 'errors[0]');
        if (errors) {
            var e = errors;
            return onError({
                inlineErrors: {},
                globalError: {
                    displayMsg: '',
                    reason: 'vgs_failure',
                    message: e.name + ": " + e.message,
                    originalException: result
                }
            });
        }
        return onSuccess();
    })["catch"](function (e) {
        var message = lodash_get_1["default"](e, 'graphQLErrors[0].extensions.responseData.error_message') ||
            lodash_get_1["default"](e, 'networkError.message') ||
            e.message ||
            JSON.stringify(e);
        onError({
            inlineErrors: {},
            globalError: {
                message: message,
                displayMsg: '',
                reason: 'vgs_failure',
                originalException: e
            }
        });
    });
}; };
/**
 * Maps the VGS form validation errors into field errors.
 *
 * @param onError Callback method to set the error.
 * @param billingAddress billing address details when applicable.
 * @returns void
 */
var handleSubmitError = function (onError, billingAddress) { return function (vgsResponseErrors) {
    var inlineErrors = {};
    Object.values(types_1.VgsFormFieldName).map(function (field) {
        var fieldErrors = vgsResponseErrors && vgsResponseErrors[field];
        if (fieldErrors) {
            var errMsg = lodash_get_1["default"](fieldErrors, "errorMessages[0]");
            var i18nErrString = VGS_VALIDATION_ERRORS.get(errMsg) ||
                VGS_VALIDATION_ERRORS.get('default');
            inlineErrors[field] = i18nErrString;
        }
    });
    // The billing address field is not from VGS. So, we need to check
    // if its filled for second card challenge.
    if (!billingAddress.addressLine1 || !billingAddress.zip) {
        inlineErrors[types_1.VgsFormFieldName.BillingAddress] = VerifyPaymentCardStrings_1["default"].required();
    }
    onError({ inlineErrors: inlineErrors, globalError: undefined });
}; };
var useVgsForm = function (isVgsLoaded, submit, formIds) {
    var _a = react_1["default"].useContext(App_1.RiskContext), experience = _a.experience, state = _a.state;
    var language = i18n_1["default"].language;
    var _b = react_1["default"].useContext(VerifyPaymentCardContext_1["default"]), paymentCard = _b.paymentCard, paymentConfig = _b.paymentConfig;
    var vgsConfig = useVgsPaymentConfig_1["default"](paymentConfig).vgsConfig;
    var _c = __read(react_1["default"].useState(null), 2), form = _c[0], setForm = _c[1];
    var _d = __read(react_1["default"].useState({}), 2), cardData = _d[0], setCardData = _d[1];
    var isCardReentry = state.challenge === enums_1.RiskActions.ReenterPaymentCard;
    var shouldCheckAddress = !isCardReentry;
    var cardNumberPlaceHolder = "XXXX XXXX XXXX " + (isCardReentry ? paymentCard.last4 : 'XXXX');
    useGenerateVgsFormEffect_1["default"]({
        cardNumberPlaceHolder: cardNumberPlaceHolder,
        formIds: formIds,
        isVgsLoaded: isVgsLoaded,
        setForm: setForm,
        setCardData: setCardData,
        vgsConfig: vgsConfig
    });
    var formSubmit = function (onSuccess, onError, billingAddress) {
        if (billingAddress === void 0) { billingAddress = {}; }
        if (!form || !form.submit) {
            throw new Error('VGS vendor form is not initialized');
        }
        return form.submit(vgsConfig.SUBMIT_URL, {
            mapDotToObject: 'merge',
            data: {
                operationName: 'cardChallengeVgsTokenizer',
                // Compile GQL query for VGS.
                query: printer_1.print(Providers_1.cardChallengeVgsTokenizerQuery),
                variables: {
                    cardData: __assign(__assign({}, cardData), billingAddress)
                }
            },
            headers: {
                'Accept-Language': language,
                'X-Experience-Id': experience || enums_1.Experience.DoorDash,
                'X-Channel-Id': CHANNEL_MARKETPLACE,
                'X-CSRFToken': simpleStore_1.readCookie('csrf_token') || ''
            }
        }, handleSubmitFinish(onSuccess, onError, submit, billingAddress, shouldCheckAddress), handleSubmitError(onError, billingAddress));
    };
    return {
        formSubmit: formSubmit
    };
};
exports["default"] = useVgsForm;
